import gql from 'graphql-tag';

import type { UtilityContext } from '@change/core/react/utilityContext';

import type { GammaCreateMediaHitMutation, GammaCreateMediaHitMutationVariables } from './createMediaHit.graphql';

export async function createMediaHit(mediaLink: string, petitionId: string, utilityContext: UtilityContext) {
	const {
		gql: { fetch },
	} = utilityContext;

	const result = await fetch<GammaCreateMediaHitMutation, GammaCreateMediaHitMutationVariables>({
		query: gql`
			mutation GammaCreateMediaHit($input: CreatePetitionCommentInput!) {
				createPetitionComment(input: $input) {
					success
					reason
					comment {
						id
						comment
					}
				}
			}
		`,
		variables: {
			input: {
				petitionId,
				comment: mediaLink,
				role: 'MEDIA_HIT_COMMENT',
			},
		},
	});

	return result.data?.createPetitionComment;
}
